<div provide-parent-form *ngIf="playout">
	<ng-template #disabledCheckbox>
		<div><bb-check class="disabled" [disabled]="true"></bb-check></div>
	</ng-template>
	
	<div class="checkbox-grid" [class.older-skins]="playoutService?.skinGeneration !== 8">
		<div class="row header">
			<div class="label"><h3>{{ 'SHOW' | translate }}</h3></div>
			<div>{{ 'START' | translate}}</div>
			<div>{{ 'PAUSE' | translate}}</div>
			<div>{{ 'HOVER' | translate}}</div>
			<div>{{ 'END' | translate}}</div>
		</div>
	
		<!-- Big play button (actually center buttons incl forward / backward) -->
		<div class="row">
			<div>{{ 'CENTER_CONTROLS' | translate }}</div>
			<div><bb-check name="playout-showBigPlayButton" [(ngModel)]="playout.showBigPlayButton" [trueValue]="'true'" [falseValue]="'false'"></bb-check></div>
			<div><bb-check name="playout-showBigPauseButtons" [(ngModel)]="playout.showBigPauseButtons" [trueValue]="'true'" [falseValue]="'false'" (ngModelChange)="unlinkPauseHoverStates()"></bb-check></div>
			<div><bb-check name="playout-showBigHoverButtons" [(ngModel)]="playout.showBigHoverButtons" [trueValue]="'true'" [falseValue]="'false'" (ngModelChange)="unlinkPauseHoverStates()"></bb-check></div>
			<div><bb-check name="playout-showBigReplayButton" [(ngModel)]="playout.showBigReplayButton" [trueValue]="'true'" [falseValue]="'false'"></bb-check></div>
		</div>

		<!-- Title-->
		<div class="row">
			<div>{{ 'TITLE' | translate }}</div>
			<div><bb-check name="playout-title" [(ngModel)]="playout.title" [trueValue]="'Show'" [falseValue]="'Hide'"></bb-check></div>
			<div><bb-check name="playout-titlePause" [(ngModel)]="playout.titlePause" [trueValue]="'Show'" [falseValue]="'Hide'" (ngModelChange)="unlinkPauseHoverStates()"></bb-check></div>
			<div><bb-check name="playout-titleHover" [(ngModel)]="playout.titleHover" [trueValue]="'Show'" [falseValue]="'Hide'" (ngModelChange)="unlinkPauseHoverStates()"></bb-check></div>
			
			<!--Only for g8 -->
			<ng-container *ngIf="playoutService?.skinGeneration !== 8"><ng-container *ngTemplateOutlet="disabledCheckbox"></ng-container></ng-container>
			<div *ngIf="playoutService?.skinGeneration >= 8"><bb-check name="playout-titleEnd" [(ngModel)]="playout.titleEnd" [trueValue]="'Show'" [falseValue]="'Hide'"></bb-check></div>
		</div>

		<!-- Author & Copyright -->
		<div class="row">
			<div >{{ 'AUTHOR_AND_COPYRIGHT' | translate }}</div>
			<div><bb-check name="playout-authorCopyright" [(ngModel)]="playout.authorCopyright" [trueValue]="'Show'" [falseValue]="'Hide'"></bb-check></div>
			<div><bb-check name="playout-authorCopyrightPause" [(ngModel)]="playout.authorCopyrightPause" [trueValue]="'Show'" [falseValue]="'Hide'" (ngModelChange)="unlinkPauseHoverStates()"></bb-check></div>
			<div><bb-check name="playout-authorCopyrightHover" [(ngModel)]="playout.authorCopyrightHover" [trueValue]="'Show'" [falseValue]="'Hide'" (ngModelChange)="unlinkPauseHoverStates()"></bb-check></div>

			<!--Only for g8 -->
			<ng-container *ngIf="playoutService?.skinGeneration !== 8"><ng-container *ngTemplateOutlet="disabledCheckbox"></ng-container></ng-container>
			<div *ngIf="playoutService?.skinGeneration >= 8"><bb-check name="playout-authorCopyrightEnd" [(ngModel)]="playout.authorCopyrightEnd" [trueValue]="'Show'" [falseValue]="'Hide'"></bb-check></div>
		</div>

		<!-- Share button -->
		<div class="row" *ngIf="playoutService?.skinGeneration >= 8">
			<div >{{ 'SHARE_BUTTON' | translate }}</div>
			<div><bb-check name="playout-shareButton" [(ngModel)]="playout.shareButton" [trueValue]="'Show'" [falseValue]="'Hide'"></bb-check></div>
			<div><bb-check name="playout-shareButtonPause" [(ngModel)]="playout.shareButtonPause" [trueValue]="'Show'" [falseValue]="'Hide'"></bb-check></div>
			<div><bb-check name="playout-shareButtonHover" [(ngModel)]="playout.shareButtonHover" [trueValue]="'Show'" [falseValue]="'Hide'"></bb-check></div>
			<div><bb-check name="playout-shareButtonEnd" [(ngModel)]="playout.shareButtonEnd" [trueValue]="'Show'" [falseValue]="'Hide'"></bb-check></div>
		</div>

		<!-- Video length (duration) (g8) -->
		<div class="row" *ngIf="playoutService?.skinGeneration >= 8">
			<div >{{ 'DURATION' | translate }}</div>
			<div><bb-check name="playout-showStartDuration" [(ngModel)]="playout.showStartDuration" [trueValue]="'true'" [falseValue]="'false'"></bb-check></div>
			<ng-container *ngTemplateOutlet="disabledCheckbox"></ng-container>
			<ng-container *ngTemplateOutlet="disabledCheckbox"></ng-container>
			<ng-container *ngTemplateOutlet="disabledCheckbox"></ng-container>
		</div>

		<!-- Moving thumbnail -->
		<div class="row">
			<div>{{ 'MOVING_THUMBNAIL' | translate }}</div>
			<div><bb-check name="playout-disableMovingThumbnail" [(ngModel)]="playout.disableMovingThumbnail" [trueValue]="'false'" [falseValue]="'true'"></bb-check></div>
			<ng-container *ngTemplateOutlet="disabledCheckbox"></ng-container>
			<ng-container *ngTemplateOutlet="disabledCheckbox"></ng-container>
			<ng-container *ngTemplateOutlet="disabledCheckbox"></ng-container>
		</div>

		<!-- Related clips -->
		<div class="row">
			<div>{{ 'RELATED_CLIPS' | translate }}</div>
			<ng-container *ngTemplateOutlet="disabledCheckbox"></ng-container>
			<div><bb-check name="playout-relatedItemsPause" [(ngModel)]="playout.relatedItemsPause" [trueValue]="'Show'" [falseValue]="'Hide'"></bb-check></div>
			<ng-container *ngTemplateOutlet="disabledCheckbox"></ng-container>
			<div><bb-check name="playout-relatedItems" [(ngModel)]="playout.relatedItems" [trueValue]="'Show'" [falseValue]="'Hide'"></bb-check></div>
		</div>

		<!-- Last video frame -->
		<div class="row">
			<div>{{ 'LAST_VIDEO_FRAME' | translate }}</div>
			<ng-container *ngTemplateOutlet="disabledCheckbox"></ng-container>
			<ng-container *ngTemplateOutlet="disabledCheckbox"></ng-container>
			<ng-container *ngTemplateOutlet="disabledCheckbox"></ng-container>
			<div><bb-check name="playout-noPosterInExitPhase" [(ngModel)]="playout.noPosterInExitPhase" [trueValue]="'true'" [falseValue]="'false'"></bb-check></div>
		</div>
	</div>

	<!-- OLD: use2018skinSettings -->
	<div  *ngIf="previewPlayer?.use2018skinSettings">
		<h3>{{ 'START_SCREEN' | translate }}</h3>

		<bb-form-element [form]="form" [label]="'AUTHOR_AND_COPYRIGHT_ALIGNMENT' | translate" *ngIf="playout.authorCopyright === 'Show'">
			<bb-select
				[(ngModel)]="playout.authorCopyrightAlign"
				name="playout-authorCopyrightAlign"
			>
				<option value="TOPLEFT">{{ 'TOP_LEFT' | translate }}</option>
				<option value="TOPRIGHT">{{ 'TOP_RIGHT' | translate }}</option>
				<option value="BOTTOMLEFT">{{ 'BOTTOM_LEFT' | translate }}</option>
				<option value="BOTTOMRIGHT">{{ 'BOTTOM_RIGHT' | translate }}</option>
			</bb-select>
		</bb-form-element>
	
		<bb-form-element [form]="form" [label]="'DATE' | translate">
			<bb-select
				[(ngModel)]="playout.date"
				name="playout-date"
			>
				<option value="Show">{{ 'SHOW' | translate }}</option>
				<option value="Hide">{{ 'HIDE' | translate }}</option>
			</bb-select>
		</bb-form-element>

		<h3>{{ 'PAUSE_SCREEN' | translate }}</h3>

		<bb-form-element [form]="form" [label]="'AUTHOR_AND_COPYRIGHT_ALIGNMENT' | translate" *ngIf="playout.authorCopyright === 'Show'">
			<bb-select
				[(ngModel)]="playout.authorCopyrightAlignPause"
				name="playout-authorCopyrightAlignPause"
			>
				<option value="TOPLEFT">{{ 'TOP_LEFT' | translate }}</option>
				<option value="TOPRIGHT">{{ 'TOP_RIGHT' | translate }}</option>
				<option value="BOTTOMLEFT">{{ 'BOTTOM_LEFT' | translate }}</option>
				<option value="BOTTOMRIGHT">{{ 'BOTTOM_RIGHT' | translate }}</option>
			</bb-select>
		</bb-form-element>
	</div>

	<!-- Author & Copyright -->
	<ng-container *ngIf="[playout.authorCopyright, playout.authorCopyrightPause, playout.authorCopyrightHover, playout.authorCopyrightEnd].includes('Show')">
		<h3>{{ 'AUTHOR_AND_COPYRIGHT' | translate }}</h3>
	
		<bb-form-element [form]="form" [label]="'AUTHOR_AND_COPYRIGHT_PREFIX_TEXT' | translate">
			<input
				type="text"
				name="playout-authorCopyrightPrefixText"
				[(ngModel)]="playout.authorCopyrightPrefixText"
			/>
		</bb-form-element> 
	</ng-container>
 
	<!-- Related items -->
	<ng-container *ngIf="playout.relatedItemsPause === 'Show' || playout.relatedItems === 'Show'">
		<h3>{{ 'RELATED_CLIPS' | translate }}</h3>
	
		<!-- note confusing prop name: pause + end screen use same setting in sync: exitscreenItemsListId -->
		<bb-form-element [form]="form" [label]="'CLIP_LIST_FOR_RELATED_CLIPS' | translate">
			<bb-entity-selector 
				name="playout-exitscreenItemsListId"
				[(ngModel)]="playout.exitscreenItemsListId"
				[entityType]="'cliplist'"
			></bb-entity-selector>
		</bb-form-element>
	 
		<bb-form-element [form]="form" [label]="'USE_DEEP_LINK_FOR_RELATED_CLIPS' | translate">
			<bb-check name="playout-useDeeplinkForRelatedItems" [(ngModel)]="playout.useDeeplinkForRelatedItems" [trueValue]="'true'" [falseValue]="'false'"></bb-check>
		</bb-form-element>
	 
		<bb-form-element [form]="form" [label]="'RANDOMIZE_RELATED_CLIPS' | translate" [hidden]="playout.relatedItems !== 'Show' && playout.autoPlayNext !== 'true'">
			<bb-check name="playout-randomizeRelatedItems" [(ngModel)]="playout.randomizeRelatedItems" [trueValue]="'true'" [falseValue]="'false'"></bb-check>
		</bb-form-element>
	</ng-container>
 
	<!-- Autoplay next -->
	<h3>{{ 'AUTOPLAY_NEXT' | translate }}</h3> 

	<bb-form-element [form]="form" [label]="'AUTOMATICALLY_PLAY_NEXT_CLIP' | translate" [helpMessage]="'HELP.AUTO_PLAY_NEXT' | translate" [helpMessageLink]="'https://support.bluebillywig.com/video-player/player-start-and-endscreen/#1-2-end-screen'">
		<bb-check name="playout-autoPlayNext" [(ngModel)]="playout.autoPlayNext" [trueValue]="'true'" [falseValue]="'false'"></bb-check>
		<p class="message warning" [hidden]="!((playout.autoPlayNext === true || playout.autoPlayNext === 'true') && (playout.autoLoop === true || playout.autoLoop === 'true'))">
			<i class="fa fa-warning"></i> <span [innerHtml]="'INFO.AUTOPLAY_NEXT_AUTO_LOOP' | translate"></span>
		</p>
	</bb-form-element>

	<bb-form-element [disabled]="playout.autoPlayNext !== 'true'" [form]="form"
		[label]="'PLAYOUT_AUTOPLAY_ONLY_WITH_PREROLL_AD' | translate"
		[helpMessage]="'PLAYOUT_AUTOPLAY_ONLY_WITH_PREROLL_AD' | translate" class="tab-indent">
		<bb-check name="playout-autoPlayOnlyWithPrerollAd" [(ngModel)]="playout.autoPlayOnlyWithPrerollAd"
			[trueValue]="'true'" [falseValue]="'false'" [class.disabled]="playout.autoPlayNext !== 'true'" >
		</bb-check>
	</bb-form-element>

	<!-- New setting for g8 -->
	<bb-form-element [disabled]="playout.autoPlayNext !== 'true'" [form]="form" *ngIf="playoutService?.skinGeneration >= 8" [label]="'AUTOPLAY_NEXT_TIMEOUT' | translate"  class="tab-indent">
		<input type="number" min="1" max="99" name="playout-autoPlayNextTimeout" [(ngModel)]="playout.autoPlayNextTimeout" />
	</bb-form-element>
 </div>
